{
    "a11y": {
        "closeDialog": "Close dialogue",
        "closeImage": "Close image view",
        "closePopup": "Close map point",
        "closeSearch": "Close search",
        "closeToc": "Close table of contents",
        "cookieSettings": "Open privacy settings",
        "downloadSection": "Download “{section}”",
        "enlargeImage": "Enlarge image",
        "imageViewer": "Image view",
        "languageMenu": "Choose language",
        "mainMenu": "Main menu",
        "mapInstructions": "Use the arrow keys to move between map points and Enter or Space to open one. Plus and minus zoom; 0 shows the whole map.",
        "mapRoleDescription": "Interactive map",
        "menu": "Menu",
        "openSearch": "Open search",
        "openToc": "Open table of contents",
        "pointsList": "Map points",
        "share": "Share this map",
        "shareVia": "Share via {network}",
        "skipToPoints": "Skip to the map points",
        "unnamedPoint": "Untitled map point",
        "videoPlayer": "Video player",
        "zoomIn": "Zoom in",
        "zoomLevel": "Zoom level {level}",
        "zoomLevelAnnounce": "Zoom level {level}, {count} map points visible",
        "zoomOut": "Zoom out",
        "zoomToFit": "Show the whole map"
    },
    "editorial": {
        "close": "Close Editor’s note",
        "defaultTitle": "Editor’s note and team",
        "team": "Team"
    },
    "gallery": {
        "next": "Next image",
        "position": "Image {index} of {total}",
        "previous": "Previous image"
    },
    "back": "back",
    "blockedMsg": "External content is blocked by your privacy settings.",
    "changePrivacySettings": "Manage privacy settings",
    "connections": "Connected with:",
    "contentLastUpdate": "Last update:",
    "acceptAll": "Accept all",
    "acceptEssentialOnly": "Accept only essential cookies",
    "imprint": "Imprint",
    "privacyPolicy": "Privacy Policy",
    "saveSettings": "Save settings",
    "title": "Privacy Settings",
    "failed": "Content could not be loaded.",
    "loading": "Loading content …",
    "socialMedia": "Share this article:",
    "resetSearch": "Reset search",
    "search": "Search",
    "zoomLevels": "Zoom levels",
    "previewNotice": "This is a preview of the latest changes, not the live view of the map."
}
